export const SEARCH = 'search';
export const DATE_RAGE_START = 'start';
export const DATE_RANGE_END = 'end';
export const DEVICE = 'device';
export const PROJECT = 'project';
export const USER = 'user';
export const DEVICE_MAP = 'device-map';
